export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-path/index.js
// module id = ../../../../d3-path/index.js
// module chunks = 3